import type { TmsContextType } from '@awazevr/mfe-common.contexts.tms'
import type {
  CommonSite,
  SearchCriteria,
} from '@awazevr/mfe-common.types-and-mocks.site-search-service'

import type { OptimizelyState } from '@/context/optimizely-decisions-context'

import {
  findClickedExpandedProperty,
  getDisplayedExpandedProperties,
} from './smartPolygonSelection'
import {
  trackPropertiesNearbyCardClick,
  trackPropertiesNearbySeen,
  trackSmartPolygonCardClick,
  trackSmartPolygonListSeen,
} from './tracking'

interface PropertiesNearbyHandlersArgs {
  tms: TmsContextType | undefined
  searchCriteria: SearchCriteria
  expandedProperties: CommonSite[]
  optimizelyState: OptimizelyState
}

interface PropertiesNearbyHandlers {
  onCardClick: (code: string, position: number) => void
  onSeen: () => void
}

// Shared by the low-results (SearchResults) and no-results (SearchLayout) call
// sites: both fire the same impression/click tracking off the displayed set.
export const buildPropertiesNearbyHandlers = ({
  tms,
  searchCriteria,
  expandedProperties,
  optimizelyState,
}: PropertiesNearbyHandlersArgs): PropertiesNearbyHandlers => {
  const displayed = getDisplayedExpandedProperties(expandedProperties)

  return {
    onCardClick: (code, position) => {
      trackPropertiesNearbyCardClick(optimizelyState)
      const clicked = findClickedExpandedProperty(displayed, code)
      if (clicked) {
        trackSmartPolygonCardClick(
          tms,
          searchCriteria,
          clicked,
          position,
          displayed.length,
        )
      }
    },
    onSeen: () => {
      trackPropertiesNearbySeen(optimizelyState, tms)
      trackSmartPolygonListSeen(tms, searchCriteria, displayed)
    },
  }
}
